export default "__VITE_ASSET__BGiSnBxO__"